/* =============================================================================
FILE: po-lexique-simplifie-runtime-20260212.js
ROLE:
  - Affiche le lexique simplifié FR/EN/ES (recherche + vue tri/mono + copie)
ROOT:
  - .po-lexique-simplifie[data-po-lexique-simplifie]
SOURCE:
  - lexique simplifié.docx (table FR/EN/ES)
============================================================================= */
(function () {
  "use strict";

  if (window.__PO_LEXIQUE_SIMPLIFIE_RUNTIME_20260212__) return;
  window.__PO_LEXIQUE_SIMPLIFIE_RUNTIME_20260212__ = true;

  var ROOT_SEL = ".po-lexique-simplifie[data-po-lexique-simplifie]";
  var STORAGE_LANG_KEY = "po_lex_simpl_lang";
  var STORAGE_VIEW_KEY = "po_lex_simpl_view"; // "tri" ou "mono"
  var STORAGE_GROUP_KEY = "po_lex_simpl_group";

  // ---------------------------------------------------------------------------
  // DATA (COMPLET) — 248 entrées
  // Format strict : { fr: "…", en: "…", es: "…" }
  // ---------------------------------------------------------------------------
    // ---------------------------------------------------------------------------
  // DATA (COMPLET) — 247 entrées
  // Organisé selon le corpus : Katûpirsia 1, 2, 3, 5, 9 (groupes + annexes)
  // Format strict : { fr: "…", en: "…", es: "…" }
  // ---------------------------------------------------------------------------
    // ---------------------------------------------------------------------------
  // DATA (COMPLET) — 248 entrées
  // Format strict : { fr: "…", en: "…", es: "…" }
  // Classement canonique conforme à "liste élémentaire 2" + familles lexicales
  // ---------------------------------------------------------------------------

  var K1_FONDATION = [
    {
      "fr": "Posœnnoïa",
      "en": "Posœnnoïa",
      "es": "Posœnnoïa"
    }
  ];

  var K1_PILIERS = [
    {
      "fr": "RéZonans",
      "en": "RéZonans",
      "es": "RéZonans"
    },
    {
      "fr": "Péroptissimisme",
      "en": "Péroptissimism",
      "es": "Péroptisimismo"
    },
    {
      "fr": "Illusion",
      "en": "Illusion",
      "es": "Ilusión"
    },
    {
      "fr": "Aliœvolution",
      "en": "Aliœvolution",
      "es": "Aliœvolución"
    }
  ];

  var K1_OUTILS = [
    {
      "fr": "Superposition de perspectives",
      "en": "Superposition of perspectives",
      "es": "Superposición de perspectives"
    },
    {
      "fr": "Instantané multiple",
      "en": "Multiple instantaneity",
      "es": "Instantáneo múltiple"
    },
    {
      "fr": "Addition synchrêtique",
      "en": "Synchrêtic addition",
      "es": "Adición sinchrêtica"
    },
    {
      "fr": "Sujet pluriel",
      "en": "Plural subject",
      "es": "Sujeto plural"
    }
  ];

  var K1_ENGRENAGES = [
    {
      "fr": "Posœnnoïque",
      "en": "Posœnnoïc",
      "es": "Posœnnoïco"
    },
    {
      "fr": "Posœnnoïaque",
      "en": "Posœnnoïac",
      "es": "Posœnnoïaco"
    }
  ];

  var K1_ANNEXES = [
    {
      "fr": "Pistis Chraomai",
      "en": "Pistis Chraomai",
      "es": "Pistis Chraomai"
    },
    {
      "fr": "Organon posœnnoïal",
      "en": "Posœnnoïal Organon",
      "es": "Organon posœnnoïal"
    }
  ];

  var K2_TEMPORALITES = [
    {
      "fr": "Temporalité élargie",
      "en": "Expanded temporality",
      "es": "Temporalidad extensiva"
    },
    {
      "fr": "Temporalité éclatée",
      "en": "Broken-out temporality",
      "es": "Temporalidad estallada"
    },
    {
      "fr": "Stratification d’expériences",
      "en": "Stratification of experiences",
      "es": "Estratificación de experiencias"
    }
  ];

  var K2_CONSCIENCES = [
    {
      "fr": "Conscience vibratoire",
      "en": "Vibratory consciousness",
      "es": "Consciencia vibratoria"
    },
    {
      "fr": "Conscientisation introspective",
      "en": "Introspective awareness",
      "es": "Concientización introspectiva"
    },
    {
      "fr": "Conscientisation dynamique",
      "en": "Dynamic awareness",
      "es": "Concientización dinámica"
    }
  ];

  var K2_LUCIDITES = [
    {
      "fr": "Lucidité structurante",
      "en": "Structuring lucidity",
      "es": "Perspicacia estructurante"
    },
    {
      "fr": "Lucidité critique",
      "en": "Critical lucidity",
      "es": "Perspicacia crítica"
    },
    {
      "fr": "Miroirs posœnnoïaux",
      "en": "Posœnnoïal mirrors",
      "es": "Espejos posœnnoïales"
    }
  ];

  var K2_ADAPTABILITES = [
    {
      "fr": "Adaptabilité critique",
      "en": "Critical adaptability",
      "es": "Adaptabilidad crítica"
    },
    {
      "fr": "Adaptabilité ouverte",
      "en": "Open adaptability",
      "es": "Adaptabilidad abierta"
    },
    {
      "fr": "Approche fluide et adaptative",
      "en": "Fluid and adaptive approach",
      "es": "Abordaje fluido y adaptable"
    }
  ];

  var K2_DECISIONS = [
    {
      "fr": "Déterminisme du choix",
      "en": "Determinism of choice",
      "es": "Determinismo de la decisión"
    },
    {
      "fr": "Myrte décisif",
      "en": "Decisive myrtle",
      "es": "Mirto decisivo"
    },
    {
      "fr": "Néotaxie",
      "en": "Neotaxy",
      "es": "Neotaxia"
    }
  ];

  var K2_DEVENIRS = [
    {
      "fr": "Identité évolutive",
      "en": "Evolving Identity",
      "es": "Identidad evolutiva"
    },
    {
      "fr": "Expérience fragmentée",
      "en": "Fragmented experience",
      "es": "Experiencia fragmentada"
    },
    {
      "fr": "Exploration de l’inconnu",
      "en": "Exploration of the Unknown Fields",
      "es": "Exploración de lo inexplorado"
    }
  ];

  var K3_UNIVERS = [
    {
      "fr": "Posœnnoïamie",
      "en": "Posœnnoïamy",
      "es": "Posœnnoïamía"
    },
    {
      "fr": "Posœnnomia",
      "en": "Posœnnomia",
      "es": "Posœnnomía"
    }
  ];

  var K3_PRATIQUES = [
    {
      "fr": "Méditations Posœnnoïales",
      "en": "Posœnnoïal meditations",
      "es": "Meditaciones posœnnoïales"
    },
    {
      "fr": "Accords Posœnnoïaux",
      "en": "Posœnnoïal agreements",
      "es": "Acuerdos posœnnoïaux"
    }
  ];

  var K5_KATUVYS = [
    {
      "fr": "Katûvýs",
      "en": "Katûvýs",
      "es": "Katûvýs"
    }
  ];

  var K5_KATUSYS = [
    {
      "fr": "Katûsýs",
      "en": "Katûsýs",
      "es": "Katûsýs"
    },
    {
      "fr": "Lulæṣírasen",
      "en": "Lulæṣírasen",
      "es": "Lulæṣírasen"
    },
    {
      "fr": "Takimarah",
      "en": "Takimarah",
      "es": "Takimarah"
    },
    {
      "fr": "Tiqqunbahu",
      "en": "Tiqqunbahu",
      "es": "Tiqqunbahu"
    },
    {
      "fr": "Taxiêlîs",
      "en": "Taxiêlîs",
      "es": "Taxiêlîs"
    },
    {
      "fr": "Katûvýsissence",
      "en": "Katûvýsissence",
      "es": "Katûvýsissence"
    },
    {
      "fr": "Ušôprogalenmestûd",
      "en": "Ušôprogalenmestûd",
      "es": "Ušôprogalenmestûd"
    },
    {
      "fr": "Extratinrieur",
      "en": "Extratinrieur",
      "es": "Extratinrieur"
    },
    {
      "fr": "Mathêsis ontologique posœnnoïale (MOPo)",
      "en": "Posœnnoïal Ontological Mathesis (MOPo)",
      "es": "Mathesis ontológica posœnnoïal (MOPo)"
    }
  ];

  var K5_BALAKALLPA = [
    {
      "fr": "Balakallpa",
      "en": "Balakallpa",
      "es": "Balakallpa"
    },
    {
      "fr": "La Katûpirsia",
      "en": "Katûpirsia",
      "es": "Katûpirsia"
    },
    {
      "fr": "Katûvýsqun",
      "en": "Katûvýsqun",
      "es": "Katûvýsqun"
    },
    {
      "fr": "Àpákan",
      "en": "Àpákan",
      "es": "Àpákan"
    },
    {
      "fr": "MOCoN",
      "en": "MOCoN",
      "es": "MOCoN"
    }
  ];

  var K5_ISQUN = [
    {
      "fr": "Isqun",
      "en": "Isqun",
      "es": "Isqun"
    },
    {
      "fr": "Ennéagone",
      "en": "Enneagon",
      "es": "Eneágono"
    },
    {
      "fr": "Sceau d’Équiphase",
      "en": "Seal of Equiphase",
      "es": "Sello de Equifase"
    },
    {
      "fr": "Sceau de Syntonie",
      "en": "Seal of Syntony",
      "es": "Sello de Sintonía"
    },
    {
      "fr": "Sceau d’Aísthisi",
      "en": "Seal of Aísthisi",
      "es": "Sello de Aísthisi"
    },
    {
      "fr": "Sceau d’Anépôron",
      "en": "Seal of Anépôron",
      "es": "Sello de Anépôron"
    },
    {
      "fr": "Sceau d’Ifẹ̀",
      "en": "Seal of Ifẹ̀",
      "es": "Sello de Ifẹ̀"
    },
    {
      "fr": "Sceau d’Ayeẹmí",
      "en": "Seal of Ayeẹmí",
      "es": "Sello de Ayeẹmí"
    },
    {
      "fr": "Sceau d’Ọ̀rọ̀yuyay",
      "en": "Seal of Ọ̀rọ̀yuyay",
      "es": "Sello de Ọ̀rọ̀yuyay"
    },
    {
      "fr": "Sceau de Yuyarina",
      "en": "Seal of Yuyarina",
      "es": "Sello de Yuyarina"
    },
    {
      "fr": "Sceau d’Œndomare",
      "en": "Seal of Œndomare",
      "es": "Sello de Œndomare"
    }
  ];

  var K5_THRENISQUN = [
    {
      "fr": "Threnisqun",
      "en": "Threnisqun",
      "es": "Threnisqun"
    },
    {
      "fr": "Ēkuphasa",
      "en": "Ēkuphasa",
      "es": "Ēkuphasa"
    },
    {
      "fr": "Syntōnēa",
      "en": "Syntōnēa",
      "es": "Syntōnēa"
    },
    {
      "fr": "Aísthēra",
      "en": "Aísthēra",
      "es": "Aísthēra"
    },
    {
      "fr": "Anēporon",
      "en": "Anēporon",
      "es": "Anēporon"
    },
    {
      "fr": "Ifẹ̀riya",
      "en": "Ifẹ̀riya",
      "es": "Ifẹ̀riya"
    },
    {
      "fr": "Ayeẹmīnê",
      "en": "Ayeẹmīnê",
      "es": "Ayeẹmīnê"
    },
    {
      "fr": "Ọ̀rōyuyān",
      "en": "Ọ̀rōyuyān",
      "es": "Ọ̀rōyuyān"
    },
    {
      "fr": "Yuyarīnâ",
      "en": "Yuyarīnâ",
      "es": "Yuyarīnâ"
    },
    {
      "fr": "Œndomarê",
      "en": "Œndomarê",
      "es": "Œndomarê"
    }
  ];

  var K5_ANNEXE_369 = [
    {
      "fr": "Triade 3–6–9",
      "en": "3–6–9 Triad",
      "es": "Tríada 3–6–9"
    },
    {
      "fr": "Spirale 3-6-9",
      "en": "Spiral 3-6-9",
      "es": "Espiral 3-6-9"
    },
    {
      "fr": "Is-T",
      "en": "Is-T",
      "es": "Is-T"
    }
  ];

  var K9_NOYAU = [
    {
      "fr": "Âṣẹxel’Or",
      "en": "Âṣẹxel’Or",
      "es": "Âṣẹxel’Or"
    },
    {
      "fr": "Axe doré",
      "en": "Golden Axis",
      "es": "Eje dorado"
    },
    {
      "fr": "Architecture d’Or",
      "en": "Golden Architecture",
      "es": "Arquitectura de Oro"
    },
    {
      "fr": "Loi d’Or",
      "en": "Golden Law",
      "es": "Ley de Oro"
    }
  ];

  var K9_INDICES = [
    {
      "fr": "492 Hz (indice d’alignement)",
      "en": "492 Hz (alignment index)",
      "es": "492 Hz (índice de alineación)"
    },
    {
      "fr": "Fréquence 492",
      "en": "Frequency 492",
      "es": "Frecuencia 492"
    },
    {
      "fr": "Fréquence-guide",
      "en": "Guide-frequency",
      "es": "Frecuencia-guía"
    },
    {
      "fr": "Nombre-guide",
      "en": "Guide-number",
      "es": "Número-guía"
    },
    {
      "fr": "Δτ",
      "en": "Δτ",
      "es": "Δτ"
    }
  ];

  var K9_CHAMP = [
    {
      "fr": "Amplitude dorée",
      "en": "Golden Amplitude",
      "es": "Amplitud dorada"
    },
    {
      "fr": "Battement d’Or",
      "en": "Golden Beat",
      "es": "Latido de Oro"
    },
    {
      "fr": "Chant d’Or",
      "en": "Golden Chant",
      "es": "Canto de Oro"
    },
    {
      "fr": "Champ d’Or",
      "en": "Golden Field",
      "es": "Campo de Oro"
    },
    {
      "fr": "Contour d’Or",
      "en": "Golden Outline",
      "es": "Contorno de Oro"
    },
    {
      "fr": "Espace d’Or",
      "en": "Golden Space",
      "es": "Espacio de Oro"
    },
    {
      "fr": "Mémoire d’Or",
      "en": "Golden Memory",
      "es": "Memoria de Oro"
    },
    {
      "fr": "Mesure d’Or",
      "en": "Golden Measure",
      "es": "Medida de Oro"
    },
    {
      "fr": "Respiration d’Or",
      "en": "Golden Respiration",
      "es": "Respiración de Oro"
    },
    {
      "fr": "Rythme d’Or",
      "en": "Golden Rhythm",
      "es": "Ritmo de Oro"
    },
    {
      "fr": "Souffle d’Or",
      "en": "Golden Breath",
      "es": "Aliento de Oro"
    }
  ];

  var K9_CYCLE = [
    {
      "fr": "Année posœnnoïale (AP)",
      "en": "Posœnnoïal Year (AP)",
      "es": "Año posœnnoïal (AP)"
    },
    {
      "fr": "Année posœnnoïale (AP) / AP 12825",
      "en": "Posœnnoïal Year (AP) / AP 12825",
      "es": "Año posœnnoïal (AP) / AP 12825"
    },
    {
      "fr": "Décade (K9)",
      "en": "Decade (K9)",
      "es": "Década (K9)"
    },
    {
      "fr": "Décade",
      "en": "Decade",
      "es": "Década"
    },
    {
      "fr": "Mois posœnnoïal",
      "en": "Posœnnoïal Month",
      "es": "Mes posœnnoïal"
    },
    {
      "fr": "Saison posœnnoïale",
      "en": "Posœnnoïal Season",
      "es": "Estación posœnnoïale"
    },
    {
      "fr": "Épagomènes",
      "en": "Epagomenal Days",
      "es": "Epágomenos"
    }
  ];

  var K9_FORMULES = [
    {
      "fr": "« Âṣẹxel’Or : j’entre dans la clarté, j’accorde le geste, et le passage devient opératif. »",
      "en": "“Âṣẹxel’Or: I enter clarity, tune the gesture, and the passage becomes operative.”",
      "es": "“Âṣẹxel’Or: entro en la claridad, ajusto el gesto, y el paso se vuelve operativo.”"
    },
    {
      "fr": "« AP : je me situe dans le cycle, j’accorde le seuil, et la traversée devient tenable. »",
      "en": "“AP: I locate myself in the cycle, tune the threshold, and the traversal becomes sustainable.”",
      "es": "“AP: me sitúo en el ciclo, ajusto el umbral, y la travesía se vuelve sostenible.”"
    },
    {
      "fr": "« 3–6–9 : je nomme la phase, j’installe la tenue, et l’expansion s’ouvre juste. »",
      "en": "“3–6–9: I name the phase, set the hold, and the expansion opens rightly.”",
      "es": "“3–6–9: nombro la fase, instalo la sostén, y la expansión se abre con justeza.”"
    },
    {
      "fr": "« Décade : je respire le cycle court, j’ajuste le rythme, et la tenue s’installe. »",
      "en": "“Decade: I breathe the short cycle, tune the rhythm, and the hold settles.”",
      "es": "“Década: respiro el ciclo corto, ajusto el ritmo, y el sostén se instala.”"
    },
    {
      "fr": "« Mois posœnnoïal : j’habite l’archétype, j’installe la tenue, et la transmutation devient praticable. »",
      "en": "“Posœnnoïal Month: I inhabit the archetype, set the hold, and transmutation becomes practicable.”",
      "es": "“Mes posœnnoïal: habito el arquetipo, instalo el sostén, y la transmutación se vuelve practicable.”"
    },
    {
      "fr": "« Épagomènes : je redistribue l’excès, j’ouvre le seuil, et l’année peut renaître. »",
      "en": "“Epagomenal Days: I redistribute the excess, open the threshold, and the year can be reborn.”",
      "es": "“Epágomenos: redistribuyo el exceso, abro el umbral, y el año puede renacer.”"
    },
    {
      "fr": "« Saison : je reconnais le régime, j’accorde la tenue, et le collectif respire. »",
      "en": "“Season: I recognize the regime, tune the hold, and the collective breathes.”",
      "es": "“Estación: reconozco el régimen, ajusto el sostén, y lo colectivo respira.”"
    }
  ];

  var FAM_EXTRATINRIEUR = [
    {
      "fr": "Extratinrieural",
      "en": "Extratinrieural",
      "es": "Extratinrieural"
    },
    {
      "fr": "Extratinrieurisation",
      "en": "Extratinrieurisation",
      "es": "Extratinrieurisation"
    },
    {
      "fr": "Extratinrieurité",
      "en": "Extratinrieurité",
      "es": "Extratinrieurité"
    },
    {
      "fr": "Extratinriorial",
      "en": "Extratinriorial",
      "es": "Extratinriorial"
    },
    {
      "fr": "Extratinriorialisation",
      "en": "Extratinriorialisation",
      "es": "Extratinriorialisation"
    },
    {
      "fr": "Extratinriorialité",
      "en": "Extratinriorialité",
      "es": "Extratinriorialité"
    },
    {
      "fr": "Extratinrioreindre",
      "en": "to Extratinriorein",
      "es": "Extratinrioreñir"
    },
    {
      "fr": "Extratinriostriction",
      "en": "Extratinriostriction",
      "es": "Extratinriostricción"
    },
    {
      "fr": "Extratinriostrictif(ve)",
      "en": "Extratinriostrictive",
      "es": "Extratinriostrictivo/a"
    },
    {
      "fr": "Extratinriostrictibilité",
      "en": "Extratinriostrictibility",
      "es": "Extratinriostrictibilidad"
    },
    {
      "fr": "Extratinriopoïétique",
      "en": "Extratinriopoietic",
      "es": "Extratinriopoietico/a"
    },
    {
      "fr": "Extratinriopoïéticité",
      "en": "Extratinriopoieticity",
      "es": "Extratinriopoieticidad"
    },
    {
      "fr": "Extratinriologiste",
      "en": "Extratinriologist",
      "es": "Extratinriólogo/a"
    },
    {
      "fr": "Extratinrieuriser",
      "en": "to extratinriorize",
      "es": "extratinriorizar"
    },
    {
      "fr": "Extratinriorialiser",
      "en": "to extratinriorialize",
      "es": "extratinriorializar"
    },
    {
      "fr": "Extratinrieur",
      "en": "Extratinrior",
      "es": "Extratinrior"
    },
    {
      "fr": "Extratinrieural",
      "en": "Extratinrioral",
      "es": "Extratinrioral"
    },
    {
      "fr": "Extratinrieurité",
      "en": "Extratinriority",
      "es": "Extratinrioridad"
    },
    {
      "fr": "Extratinriorialité",
      "en": "Extratinrioriality",
      "es": "Extratinriorialidad"
    },
    {
      "fr": "Extratinrieurisation",
      "en": "Extratinriorization",
      "es": "Extratinriorización"
    },
    {
      "fr": "Extratinriorialisation",
      "en": "Extratinriorialization",
      "es": "Extratinriorialización"
    },
    {
      "fr": "Extratinrioreindre",
      "en": "to extratinriorein",
      "es": "extratinrioringir"
    },
    {
      "fr": "Extratinriostriction",
      "en": "extratinriostriction",
      "es": "extratinriostricción"
    },
    {
      "fr": "Extratinriostrictif(ve)",
      "en": "extratinriostrictive",
      "es": "extratinriostrictivo/a"
    },
    {
      "fr": "Extratinriostrictibilité",
      "en": "extratinriostrictibility",
      "es": "extratinriostrictibilidad"
    },
    {
      "fr": "Extratinriopoïétique",
      "en": "extratinriopoietic",
      "es": "extratinriopoiético/a"
    },
    {
      "fr": "Extratinriopoïéticité",
      "en": "extratinriopoieticity",
      "es": "extratinriopoiéticidad"
    },
    {
      "fr": "Extratinriologiste",
      "en": "extratinriologist",
      "es": "extratinriologista"
    }
  ];

  var FAM_REZONANS = [
    {
      "fr": "RéZonanser",
      "en": "to RéZonanse",
      "es": "RéZonansar"
    },
    {
      "fr": "RéZoindre",
      "en": "to RéZoind",
      "es": "RéZoiñir"
    },
    {
      "fr": "RéZonansité",
      "en": "RéZonansity",
      "es": "RéZonansidad"
    },
    {
      "fr": "RéZonansement",
      "en": "RéZonansement",
      "es": "RéZonansamiento"
    },
    {
      "fr": "RéZonansialisation",
      "en": "RéZonansialization",
      "es": "RéZonansialización"
    },
    {
      "fr": "réZonansant(e)",
      "en": "réZonansing",
      "es": "réZonansante"
    },
    {
      "fr": "réZonansatif/ve",
      "en": "réZonansative",
      "es": "réZonansativo/a"
    },
    {
      "fr": "réZonansatoire",
      "en": "réZonansatory",
      "es": "réZonansatorio"
    },
    {
      "fr": "réZonansant",
      "en": "RéZonansing",
      "es": "RéZonansante"
    },
    {
      "fr": "réZonansatif/ve",
      "en": "RéZonansative",
      "es": "RéZonansativo/a"
    },
    {
      "fr": "réZonansatoire",
      "en": "RéZonansatory",
      "es": "RéZonansatorio"
    }
  ];

  var FAM_NEOTAXIE = [
    {
      "fr": "Néotaxisme",
      "en": "Neotaxism",
      "es": "Neotaxismo"
    },
    {
      "fr": "Néotaxionomie",
      "en": "Neotaxionomy",
      "es": "Neotaxionomía"
    },
    {
      "fr": "Néotaxionomiste",
      "en": "Neotaxionomist",
      "es": "Neotaxionomista"
    },
    {
      "fr": "Néotaxiation",
      "en": "Neotaxiation",
      "es": "Neotaxiación"
    },
    {
      "fr": "Néotaxiatisation",
      "en": "Néotaxiatization",
      "es": "Neotaxiatización"
    },
    {
      "fr": "Néotaxission",
      "en": "Néotaxission",
      "es": "Neotaxisión"
    },
    {
      "fr": "Néotaxier",
      "en": "to neotaxize",
      "es": "neotaxiar"
    },
    {
      "fr": "Néotaxir",
      "en": "to neotaxir",
      "es": "neotaxir"
    },
    {
      "fr": "Néotaxindre",
      "en": "to neotaxin",
      "es": "neotaxingir"
    },
    {
      "fr": "Néotaxique",
      "en": "neotaxic",
      "es": "neotáxico/a"
    },
    {
      "fr": "Néotaxiatif(ve)",
      "en": "neotaxiative",
      "es": "neotaxiativo/a"
    },
    {
      "fr": "Néotaxiactif(ve)",
      "en": "neotaxiactive",
      "es": "neotaxiactivo/a"
    },
    {
      "fr": "Néotaxiactivité",
      "en": "Neotaxy-activity",
      "es": "Neotaxiactividad"
    },
    {
      "fr": "Néotaxiogène",
      "en": "Neotaxygenic",
      "es": "Neotaxiogénico/a"
    },
    {
      "fr": "Néotaxiatisation",
      "en": "Neotaxiatization",
      "es": "Neotaxiatización"
    },
    {
      "fr": "Néotaxission",
      "en": "Neotaxission",
      "es": "Neotaxisión"
    },
    {
      "fr": "Néotaxindre",
      "en": "to neotaxein",
      "es": "neotaxingir"
    },
    {
      "fr": "Néotaxiogène",
      "en": "neotaxiogenic",
      "es": "neotaxiogénico/a"
    },
    {
      "fr": "Néotaxiste",
      "en": "neotaxist",
      "es": "neotaxista"
    }
  ];

  var FAM_ALIOEVOLUTION = [
    {
      "fr": "Aliœvoluant(e)",
      "en": "Aliœvolving",
      "es": "Aliœvoluante"
    },
    {
      "fr": "Aliœvoluer",
      "en": "to Aliœvolve",
      "es": "Aliœvoluar"
    },
    {
      "fr": "Aliœvolutif(ve)",
      "en": "Aliœvolutive",
      "es": "Aliœvolutivo/a"
    },
    {
      "fr": "Aliœvolutivité",
      "en": "Aliœvolutivity",
      "es": "Aliœvoluidad"
    },
    {
      "fr": "Aliœvoluteur/trice",
      "en": "Aliœvoluter",
      "es": "Aliœvolutor/a"
    },
    {
      "fr": "Aliœvolutant(e)",
      "en": "Aliœvoluting",
      "es": "Aliœvolutante"
    },
    {
      "fr": "Aliœvoluté(e)",
      "en": "Aliœvoluted",
      "es": "Aliœvolutado/a"
    },
    {
      "fr": "Aliœvolutionner",
      "en": "to Aliœvolutionize",
      "es": "Aliœvolucionar"
    },
    {
      "fr": "Aliœvolutionnement",
      "en": "Aliœvolutioning",
      "es": "Aliœvolucionamiento"
    },
    {
      "fr": "Aliœvolutionnel(le)",
      "en": "Aliœvolutional",
      "es": "Aliœvolucional"
    },
    {
      "fr": "Aliœvolutisation",
      "en": "Aliœvolutization",
      "es": "Aliœvolutización"
    },
    {
      "fr": "Aliœvolutisable",
      "en": "Aliœvolutizable",
      "es": "Aliœvolutizable"
    },
    {
      "fr": "Raliœvolution",
      "en": "Raliœvolution",
      "es": "Raliœvolución"
    },
    {
      "fr": "Raliœvoluer",
      "en": "to Raliœvolve",
      "es": "Raliœvoluar"
    },
    {
      "fr": "Raliœvoluant(e)",
      "en": "Raliœvolving",
      "es": "Raliœvoluante"
    },
    {
      "fr": "Raliœvolutif(ve)",
      "en": "Raliœvolutive",
      "es": "Raliœvolutivo/a"
    },
    {
      "fr": "Raliœvolutibilité",
      "en": "Raliœvolutibility",
      "es": "Raliœvolutibilidad"
    }
  ];

  var FAM_POSOENNOMNESE = [
    {
      "fr": "Posœnnomnèse",
      "en": "Posœnnomnesis",
      "es": "Posœnnomnesis"
    },
    {
      "fr": "Posœnnomnéser",
      "en": "to posœnnomnese",
      "es": "posœnnomnesar"
    },
    {
      "fr": "Posœnnomnésant(e)",
      "en": "posœnnomnesing",
      "es": "posœnnomnesante"
    },
    {
      "fr": "Posœnnomnésé(e)",
      "en": "posœnnomnesed",
      "es": "posœnnomnesado/a"
    },
    {
      "fr": "Posœnnomnésique",
      "en": "posœnnomnesic",
      "es": "posœnnomnésico/a"
    },
    {
      "fr": "Posœnnomnésif(ve)",
      "en": "—",
      "es": "—"
    },
    {
      "fr": "Posœnnomnète",
      "en": "posœnnomnet",
      "es": "posœnnomneta"
    },
    {
      "fr": "Posœnnomnésie",
      "en": "posœnnomnesia",
      "es": "posœnnomnesia"
    },
    {
      "fr": "Posœnnomnésitivité",
      "en": "posœnnomnésitivity",
      "es": "posœnnomnésitividad"
    },
    {
      "fr": "Posœnnomnésitisation",
      "en": "posœnnomnisization",
      "es": "posœnnomnisización"
    },
    {
      "fr": "Posœnnomnésiquement",
      "en": "posœnnomnesically",
      "es": "posœnnomnesicamente"
    },
    {
      "fr": "Posœnnomnésitivité",
      "en": "posœnnomnesitivity",
      "es": "posœnnomnesitividad"
    },
    {
      "fr": "Posœnnomnésitisation",
      "en": "posœnnomnesization",
      "es": "posœnnomnesización"
    },
    {
      "fr": "Posœnnomnèse",
      "en": "Posœnnomnèse",
      "es": "Posœnnomnèse"
    }
  ];

  var FAM_PEROPTISSIMISME = [
    {
      "fr": "Péroptissimiser",
      "en": "to péroptissimize",
      "es": "peroptissimizar"
    },
    {
      "fr": "Péroptissimiste",
      "en": "péroptissimist",
      "es": "peroptissimista"
    },
    {
      "fr": "Péroptissimiser",
      "en": "to péroptissimize",
      "es": "péroptisimizar"
    },
    {
      "fr": "Péroptissimiste",
      "en": "péroptissimist",
      "es": "péroptisimista"
    },
    {
      "fr": "Péroptissimismal(e)",
      "en": "péroptissimismal",
      "es": "péroptisimismal"
    },
    {
      "fr": "Péroptissimismatif(ve)",
      "en": "Péroptissimismative",
      "es": "Péroptisimismativo/a"
    },
    {
      "fr": "Péroptissimisation",
      "en": "péroptissimization",
      "es": "péroptisimización"
    },
    {
      "fr": "Péroptissimission",
      "en": "péroptissimission",
      "es": "péroptisimisión"
    },
    {
      "fr": "Péroptissimismation",
      "en": "péroptissimismation",
      "es": "péroptisimismación"
    }
  ];

  var FAM_SYNCHRETISME = [
    {
      "fr": "Synchrêtique",
      "en": "Synchrêtic",
      "es": "Sinchrêtico/a"
    },
    {
      "fr": "Synchrêtisme",
      "en": "Synchrêtism",
      "es": "Sinchrêtismo"
    },
    {
      "fr": "Synchrêtique",
      "en": "Synchrêtic",
      "es": "Sinchrêtico/a"
    },
    {
      "fr": "Synchrêtiser",
      "en": "to synchrêtize",
      "es": "sinchrêtizar"
    },
    {
      "fr": "Synchrêtir",
      "en": "to synchrêtir",
      "es": "sinchrêtir"
    },
    {
      "fr": "Synchrêtisation",
      "en": "Synchrêtization",
      "es": "Sinchrêtización"
    },
    {
      "fr": "Synchrêtation",
      "en": "Synchrêtation",
      "es": "Sinchrêtación"
    },
    {
      "fr": "Synchrêtatisation",
      "en": "Synchrêtatization",
      "es": "Sinchrêtatización"
    },
    {
      "fr": "Synchrêtion",
      "en": "Synchrêtion",
      "es": "Sinchrêción"
    },
    {
      "fr": "Synchrêtif / Synchrêtive",
      "en": "Synchrêtive",
      "es": "Sinchrêtivo/a"
    },
    {
      "fr": "Synchrêtatif / Synchrêtative",
      "en": "Synchrêtative",
      "es": "Sinchrêtativo/a"
    }
  ];

  var DIVERS = [
    {
      "fr": "ἠχώ (onde) + ἔχω (tenue)",
      "en": "ἠχώ + ἔχω",
      "es": "ἠχώ + ἔχω"
    },
    {
      "fr": "Déterminisme probabiliste",
      "en": "Probabilistic determinism",
      "es": "Determinismo probabilístico"
    },
    {
      "fr": "Engrenages Posœnnoïaux",
      "en": "Posœnnoïal Gears",
      "es": "Engranajes posœnnoïales"
    },
    {
      "fr": "Katûpirsia",
      "en": "Katûpirsia",
      "es": "Katûpirsia"
    },
    {
      "fr": "Humanus",
      "en": "Humanus",
      "es": "Humanus"
    },
    {
      "fr": "Numéris",
      "en": "Numéris",
      "es": "Numéris"
    },
    {
      "fr": "Posœnnoïal",
      "en": "Posœnnoïal",
      "es": "Posœnnoïal"
    },
    {
      "fr": "Posœnnoïsme",
      "en": "Posœnnoïsm",
      "es": "Posœnnoísmo"
    },
    {
      "fr": "Système posœnnoïal",
      "en": "Posœnnoïal system",
      "es": "Sistema posœnnoïal"
    },
    {
      "fr": "Êkhö",
      "en": "Êkhö",
      "es": "Êkhö"
    },
    {
      "fr": "Mesure faible",
      "en": "Weak measure",
      "es": "Medida débil"
    },
    {
      "fr": "Sceau",
      "en": "Seal",
      "es": "Sello"
    },
    {
      "fr": "Synchrêindre",
      "en": "to synchrêin",
      "es": "sinchrêingir"
    },
    {
      "fr": "Synchrêssion",
      "en": "Synchrêssion",
      "es": "Sinchrêssión"
    },
    {
      "fr": "Superposition de perspectives",
      "en": "Superposition of perspectives",
      "es": "Superposición de perspectivas"
    },
    {
      "fr": "Accords Posœnnoïaux",
      "en": "Posœnnoïal Accords",
      "es": "Acuerdos posœnnoïaux"
    },
    {
      "fr": "Exploration de l’inconnu",
      "en": "Exploration of the Unknown Fields",
      "es": "Exploración de lo no-integrado"
    },
    {
      "fr": "Mathêsis ontologique posœnnoïale (MOPo)",
      "en": "MOPo",
      "es": "MOPo"
    },
    {
      "fr": "Sceau d’Aísthisi",
      "en": "Seal of Aisthesis",
      "es": "Sello de Aísthisi"
    },
    {
      "fr": "Sceau d’Anépôron",
      "en": "Seal of Aneporon",
      "es": "Sello de Anépôron"
    },
    {
      "fr": "Sceau d’Œndomare",
      "en": "Seal of Oendomare",
      "es": "Sello de Œndomare"
    },
    {
      "fr": "Sceau d’Équiphase",
      "en": "Seal of Équiphase",
      "es": "Sello de Équiphase"
    },
    {
      "fr": "Sceau de Syntonie",
      "en": "Seal of Syntonie",
      "es": "Sello de Sintonía"
    },
    {
      "fr": "Totem",
      "en": "Totem",
      "es": "Tótem"
    },
    {
      "fr": "Résonance autonome écosophique ajustante",
      "en": "Ecosophic autonomous adjusting resonance",
      "es": "Resonancia autónoma ecosófica ajustante"
    },
    {
      "fr": "Transformer / moduler / amplifier / réduire",
      "en": "Transform / modulate / amplify / reduce",
      "es": "Transformar / modular / amplificar / reducir"
    },
    {
      "fr": "Seuil / milieu / intensités",
      "en": "Threshold / milieu / intensities",
      "es": "Umbral / medio / intensidades"
    },
    {
      "fr": "« Humanus : je perçois, je respire, et le passage devient habitable. »",
      "en": "“Humanus: I perceive, I breathe, and the passage becomes habitable.”",
      "es": "“Humanus: percibo, respiro, y el paso se vuelve habitable.”"
    },
    {
      "fr": "Numéris",
      "en": "Numeris",
      "es": "Numéris"
    },
    {
      "fr": "« Numéris : je lis le rythme, j’accorde le nombre, et l’action devient lisible. »",
      "en": "“Numéris: I read the rhythm, tune the number, and the action becomes legible.”",
      "es": "“Numéris: leo el ritmo, ajusto el número, y la acción se vuelve legible.”"
    },
    {
      "fr": "« Δτ : je tiens le seuil, j’accorde le souffle, et le passage devient traversable. »",
      "en": "“Δτ: I hold the threshold, tune the breath, and the passage becomes traversable.”",
      "es": "“Δτ: sostengo el umbral, ajusto el aliento, y el paso se vuelve transitable.”"
    }
  ];

  function tagGroup(arr, gid) {
    if (!arr || !arr.length) return arr;
    for (var i = 0; i < arr.length; i++) {
      var it = arr[i];
      if (it && typeof it === "object") it.__g = gid;
    }
    return arr;
  }

  var GROUPS = [
    { id: "all", label: "Tout afficher" },
    { id: "k1_fondation", label: "Katûpirsia 1 — Fondation" },
    { id: "k1_piliers", label: "Katûpirsia 1 — 4 Piliers" },
    { id: "k1_outils", label: "Katûpirsia 1 — 4 Outils" },
    { id: "k1_engrenages", label: "Katûpirsia 1 — 2 Engrenages" },
    { id: "k1_annexes", label: "Katûpirsia 1 — Annexes" },
    { id: "k2_temporalites", label: "Katûpirsia 2 — Temporalités" },
    { id: "k2_consciences", label: "Katûpirsia 2 — Consciences" },
    { id: "k2_lucidites", label: "Katûpirsia 2 — Lucidités" },
    { id: "k2_adaptabilites", label: "Katûpirsia 2 — Adaptabilités" },
    { id: "k2_decisions", label: "Katûpirsia 2 — Décisions" },
    { id: "k2_devenirs", label: "Katûpirsia 2 — Devenirs" },
    { id: "k3_univers", label: "Katûpirsia 3 — 2 Univers" },
    { id: "k3_pratiques", label: "Katûpirsia 3 — 2 Pratiques" },
    { id: "k5_katuvys", label: "Katûpirsia 5 — Katûvýs" },
    { id: "k5_katusys", label: "Katûpirsia 5 — Katûsýs" },
    { id: "k5_balakallpa", label: "Katûpirsia 5 — Balakallpa" },
    { id: "k5_isqun", label: "Katûpirsia 5 — Isqun + Sceaux" },
    { id: "k5_threnisqun", label: "Katûpirsia 5 — Threnisqun" },
    { id: "k5_annexe_369", label: "Katûpirsia 5 — Annexe 3–6–9" },
    { id: "k9_noyau", label: "K9 — Noyau axial" },
    { id: "k9_indices", label: "K9 — Fréquence et indices" },
    { id: "k9_champ", label: "K9 — Champ et structures dorées" },
    { id: "k9_cycle", label: "K9 — Cycle posœnnoïal" },
    { id: "k9_formules", label: "K9 — Formules opératives" },
    { id: "fam_extratinrieur", label: "Famille lexicale — Extratinrieur" },
    { id: "fam_rezonans", label: "Famille lexicale — RéZonans" },
    { id: "fam_neotaxie", label: "Famille lexicale — Néotaxie" },
    { id: "fam_alioevolution", label: "Famille lexicale — Aliœvolution" },
    { id: "fam_posoennomnese", label: "Famille lexicale — Posœnnomnèse" },
    { id: "fam_peroptissimisme", label: "Famille lexicale — Péroptissimisme" },
    { id: "fam_synchretisme", label: "Famille lexicale — Synchrêtisme" },
    { id: "divers", label: "Divers / hors classement" }
  ];

  // Attribution des groupes (exclusive, 1 entrée = 1 groupe)
  tagGroup(K1_FONDATION, "k1_fondation");
  tagGroup(K1_PILIERS, "k1_piliers");
  tagGroup(K1_OUTILS, "k1_outils");
  tagGroup(K1_ENGRENAGES, "k1_engrenages");
  tagGroup(K1_ANNEXES, "k1_annexes");
  tagGroup(K2_TEMPORALITES, "k2_temporalites");
  tagGroup(K2_CONSCIENCES, "k2_consciences");
  tagGroup(K2_LUCIDITES, "k2_lucidites");
  tagGroup(K2_ADAPTABILITES, "k2_adaptabilites");
  tagGroup(K2_DECISIONS, "k2_decisions");
  tagGroup(K2_DEVENIRS, "k2_devenirs");
  tagGroup(K3_UNIVERS, "k3_univers");
  tagGroup(K3_PRATIQUES, "k3_pratiques");
  tagGroup(K5_KATUVYS, "k5_katuvys");
  tagGroup(K5_KATUSYS, "k5_katusys");
  tagGroup(K5_BALAKALLPA, "k5_balakallpa");
  tagGroup(K5_ISQUN, "k5_isqun");
  tagGroup(K5_THRENISQUN, "k5_threnisqun");
  tagGroup(K5_ANNEXE_369, "k5_annexe_369");
  tagGroup(K9_NOYAU, "k9_noyau");
  tagGroup(K9_INDICES, "k9_indices");
  tagGroup(K9_CHAMP, "k9_champ");
  tagGroup(K9_CYCLE, "k9_cycle");
  tagGroup(K9_FORMULES, "k9_formules");
  tagGroup(FAM_EXTRATINRIEUR, "fam_extratinrieur");
  tagGroup(FAM_REZONANS, "fam_rezonans");
  tagGroup(FAM_NEOTAXIE, "fam_neotaxie");
  tagGroup(FAM_ALIOEVOLUTION, "fam_alioevolution");
  tagGroup(FAM_POSOENNOMNESE, "fam_posoennomnese");
  tagGroup(FAM_PEROPTISSIMISME, "fam_peroptissimisme");
  tagGroup(FAM_SYNCHRETISME, "fam_synchretisme");
  tagGroup(DIVERS, "divers");

  // Assemblage final (ordre canonique : K1 → K2 → K3 → K5 → K9 → Familles → Divers)
  var DATA = [].concat(
    K1_FONDATION,
    K1_PILIERS,
    K1_OUTILS,
    K1_ENGRENAGES,
    K1_ANNEXES,
    K2_TEMPORALITES,
    K2_CONSCIENCES,
    K2_LUCIDITES,
    K2_ADAPTABILITES,
    K2_DECISIONS,
    K2_DEVENIRS,
    K3_UNIVERS,
    K3_PRATIQUES,
    K5_KATUVYS,
    K5_KATUSYS,
    K5_BALAKALLPA,
    K5_ISQUN,
    K5_THRENISQUN,
    K5_ANNEXE_369,
    K9_NOYAU,
    K9_INDICES,
    K9_CHAMP,
    K9_CYCLE,
    K9_FORMULES,
    FAM_EXTRATINRIEUR,
    FAM_REZONANS,
    FAM_NEOTAXIE,
    FAM_ALIOEVOLUTION,
    FAM_POSOENNOMNESE,
    FAM_PEROPTISSIMISME,
    FAM_SYNCHRETISME,
    DIVERS
  );


function qs(root, sel) { return root.querySelector(sel); }
  function clampStr(v) { return (v == null) ? "" : String(v); }

  function normForSearch(s) {
    return clampStr(s)
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getLang(root) {
    var v = localStorage.getItem(STORAGE_LANG_KEY);
    if (v === "fr" || v === "en" || v === "es") return v;
    var htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (htmlLang.indexOf("es") === 0) return "es";
    if (htmlLang.indexOf("en") === 0) return "en";
    return (root.getAttribute("data-default-lang") || "fr");
  }

  function setLang(lang) { localStorage.setItem(STORAGE_LANG_KEY, lang); }

  function getView(root) {
    var v = localStorage.getItem(STORAGE_VIEW_KEY);
    if (v === "tri" || v === "mono") return v;
    return (root.getAttribute("data-default-view") || "tri");
  }

  function setView(view) { localStorage.setItem(STORAGE_VIEW_KEY, view); }

  function getGroup(root) {
    var v = "";
    try { v = localStorage.getItem(STORAGE_GROUP_KEY) || ""; } catch (e) { v = ""; }

    // Compat anciens ids (versions précédentes)
    var map = {
      "k1_axis": "k1_annexes",
      "k2_fondement": "k1_fondement",
      "k2_piliers": "k1_piliers",
      "k2_piliers_annexes": "k1_piliers_annexes",
      "k2_outils": "k1_outils",
      "k2_outils_annexes": "k1_outils_annexes",
      "k2_engrenages": "k1_engrenages",
      "k2_pratiques": "k3_pratiques",
      "k2_univers": "k3_univers",
      "k2_extratinrieur_famille": "k5_extratinrieur_famille",
      "k2_phrases": "k9_phrases",
      "k2_divers": "divers"
    };
    if (v && map[v]) v = map[v];

    if (v) return v;

    var d = (root.getAttribute("data-default-group") || "all");
    if (map[d]) d = map[d];
    return d;
  }

  function setGroup(gid) {
    try { localStorage.setItem(STORAGE_GROUP_KEY, gid); } catch (e) {}
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

    function buildRowTri(item) {
    return (
      "<tr>" +
        '<td class="po-lex-cell"><span class="po-lex-term notranslate" translate="no">' + escapeHTML(item.fr) + "</span></td>" +
        '<td class="po-lex-cell"><span class="po-lex-term notranslate" translate="no">' + escapeHTML(item.en) + "</span></td>" +
        '<td class="po-lex-cell"><span class="po-lex-term notranslate" translate="no">' + escapeHTML(item.es) + "</span></td>" +
        '<td class="po-lex-actions">' +
          '<button type="button" class="po-lex-btn notranslate" translate="no" data-copy="fr">FR</button>' +
          '<button type="button" class="po-lex-btn notranslate" translate="no" data-copy="en">EN</button>' +
          '<button type="button" class="po-lex-btn notranslate" translate="no" data-copy="es">ES</button>' +
        "</td>" +
      "</tr>"
    );
  }

    function buildRowMono(item, lang) {
    var v = item[lang] || "";
    return (
      "<tr>" +
        '<td class="po-lex-cell po-lex-mono">' +
          '<span class="po-lex-term notranslate" translate="no">' + escapeHTML(v) + "</span>" +
          '<span class="po-lex-badge notranslate" translate="no">' + lang.toUpperCase() + "</span>" +
        "</td>" +
        '<td class="po-lex-actions">' +
          '<button type="button" class="po-lex-btn notranslate" translate="no" data-copy="' + escapeHTML(lang) + '">Copier</button>' +
        "</td>" +
      "</tr>"
    );
  }

  function render(root, state) {
    var tableHeadTri = qs(root, "[data-po-lex-head-tri]");
    var tableHeadMono = qs(root, "[data-po-lex-head-mono]");
    var tbody = qs(root, "[data-po-lex-body]");
    if (!tbody) return;

    var q = normForSearch(state.query);
    var out = [];

    for (var i = 0; i < DATA.length; i++) {
      var it = DATA[i];
      if (!it || typeof it !== "object") continue;
      var hay = normForSearch((it.fr || "") + " " + (it.en || "") + " " + (it.es || ""));
      if (q && hay.indexOf(q) === -1) continue;

      if (state.group && state.group !== "all") {
        if (it.__g !== state.group) continue;
      }

      if (state.view === "tri") out.push(buildRowTri(it));
      else out.push(buildRowMono(it, state.lang));
    }

    if (tableHeadTri) tableHeadTri.style.display = (state.view === "tri") ? "" : "none";
    if (tableHeadMono) tableHeadMono.style.display = (state.view === "mono") ? "" : "none";

        var col = (state.view === "tri") ? 4 : 2;

    tbody.innerHTML = out.join("") || ('<tr><td class="po-lex-empty" colspan="' + col + '">Aucun résultat.</td></tr>');

    var countEl = qs(root, "[data-po-lex-count]");
    if (countEl) countEl.textContent = String(out.length);
  }

  function copyText(txt) {
    txt = clampStr(txt);
    if (!txt) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).catch(function(){});
      return;
    }
    var ta = document.createElement("textarea");
    ta.value = txt;
    ta.setAttribute("readonly", "readonly");
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); } catch(e) {}
    document.body.removeChild(ta);
  }

  function initOne(root) {
    if (root.__poLexInited) return;
    root.__poLexInited = true;

    var state = { lang: getLang(root), view: getView(root), group: getGroup(root), query: "" };

    var input = qs(root, "[data-po-lex-search]");
    var groupSel = qs(root, "[data-po-lex-group]");
    var btnFR = qs(root, '[data-po-lex-lang="fr"]');
    var btnEN = qs(root, '[data-po-lex-lang="en"]');
    var btnES = qs(root, '[data-po-lex-lang="es"]');
    var btnTri = qs(root, '[data-po-lex-view="tri"]');
    var btnMono = qs(root, '[data-po-lex-view="mono"]');

    function syncButtons() {
      if (groupSel && groupSel.__poGroupFilled !== true && typeof GROUPS !== "undefined") {
        groupSel.__poGroupFilled = true;
        var opts = [];
        for (var gi = 0; gi < GROUPS.length; gi++) {
          var g = GROUPS[gi];
          if (!g || !g.id) continue;
          opts.push('<option value="' + escapeHTML(g.id) + '">' + escapeHTML(g.label || g.id) + "</option>");
        }
        groupSel.innerHTML = opts.join("\n");
      }
      if (groupSel) groupSel.value = state.group || "all";
      var langBtns = [btnFR, btnEN, btnES];
      for (var i = 0; i < langBtns.length; i++) {
        if (!langBtns[i]) continue;
        var isOn = (langBtns[i].getAttribute("data-po-lex-lang") === state.lang);
        langBtns[i].setAttribute("aria-pressed", isOn ? "true" : "false");
      }
      var viewBtns = [btnTri, btnMono];
      for (var j = 0; j < viewBtns.length; j++) {
        if (!viewBtns[j]) continue;
        var isV = (viewBtns[j].getAttribute("data-po-lex-view") === state.view);
        viewBtns[j].setAttribute("aria-pressed", isV ? "true" : "false");
      }
    }

    if (input) {
      input.addEventListener("input", function () {
        state.query = input.value || "";
        render(root, state);
      });
    }

    
    if (groupSel) {
      groupSel.addEventListener("change", function () {
        state.group = groupSel.value || "all";
        setGroup(state.group);
        render(root, state);
      });
    }

function bindLang(btn, lang) {
      if (!btn) return;
      btn.addEventListener("click", function () {
        state.lang = lang;
        setLang(lang);
        syncButtons();
        render(root, state);
      });
    }
    bindLang(btnFR, "fr");
    bindLang(btnEN, "en");
    bindLang(btnES, "es");

    function bindView(btn, view) {
      if (!btn) return;
      btn.addEventListener("click", function () {
        state.view = view;
        setView(view);
        syncButtons();
        render(root, state);
      });
    }
    bindView(btnTri, "tri");
    bindView(btnMono, "mono");

    root.addEventListener("click", function (ev) {
      var t = ev.target;
      if (!t) return;
      var copyLang = t.getAttribute("data-copy");
      if (copyLang) {
        var tr = t.closest("tr");
        if (!tr) return;
        var termEls = tr.querySelectorAll(".po-lex-term");
        if (state.view === "tri") {
          var idx = (copyLang === "fr") ? 0 : (copyLang === "en") ? 1 : 2;
          var el = termEls[idx];
          copyText(el ? el.textContent : "");
        } else {
          copyText(termEls[0] ? termEls[0].textContent : "");
        }
        t.classList.add("po-lex-copied");
        setTimeout(function(){ t.classList.remove("po-lex-copied"); }, 650);
      }
    });

    syncButtons();
    render(root, state);
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
})();